import { BaseWebComponentElement } from '../../framework/BaseWebComponentElement';
import { NetworkV2AppController } from '../controller/NetworkV2AppController';
import { API_TYPE_NIRVANA } from '../../webcomponents.constants';
import { translateFn } from '../../utils/translator.helper';
import { getTimezone } from '../../utils/global.utils';
import { NetworkGridAppExternalParams } from '../../networkV2/networkAppContainer/helpers/types';

export class NetworkV2AppWebComponent extends BaseWebComponentElement {
  private _externalParams: NetworkGridAppExternalParams = {};

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: NetworkV2AppController,
    });

    this.injectDependencies({ api: { type: API_TYPE_NIRVANA }, translateFn: translateFn, getTimezone: getTimezone });
  }

  set externalParams(params: NetworkGridAppExternalParams) {
    this._externalParams = params;
  }

  get externalParams(): NetworkGridAppExternalParams {
    return this._externalParams;
  }
}
